module.exports = __webpack_public_path__ + "img/bitmap@2x.81c9597b.jpg";